export const changeCropVarietySelectedReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_CropVarietySelected":
      return action.payload.CropVarietySelected;
    default:
      return state;
  }
};
